export default __webpack_public_path__ + "static/media/no_image_one.60e68fb8.jpg";